<template>
  <div class="w-100">
    <GlobalNav ref="globalNav" />
    <v-container
      class="parent-container"
      id="parent-container"
      style="
        background-color: rgba(46, 152, 158, 0.04);
        border-radius: 24px 24px 0 0;
        margin-top: 0%;
        max-width: 1610px;
      "
      :style="{ minHeight: `calc(100vh - ${globalNavHeight}px)` }"
    >
      <v-row class="modules-type">
        <v-col
          v-for="module in modules"
          :key="module.id"
          v-show="showCampaignCard || module.id !== 'campaign'"
          cols="6"
          sm="4"
          md="4"
          lg="3"
          class="mb-6"
        >
          <router-link
            @click="getModuleData(module.id)"
            :class="{
              'disabled-module': !HavePermission(module.permission),
            }"
            style="text-decoration: none"
            :to="!HavePermission(module.permission) ? '#' : module.to"
            v-tooltip:top="
              !HavePermission(module.permission)
                ? `⛔ ${$t('not_authorized')}`
                : $t(module.label)
            "
          >
            <div class="card">
              <div class="header">
                <img class="iconhed" :src="module.icon" alt="" />
              </div>
              <div class="card-body">
                <p>{{ $t(module.label) }}</p>
              </div>
            </div>
          </router-link>
        </v-col>
      </v-row>
      <v-row class="posts-scheduled px-4 py-5 mx-4 mt-16 d-none">
        <v-col cols="12" class="mb-3 header-post">
          <p class="title">
            {{ $t("Poststoday") }}
            <span
              >Wed 16<sub style="color: rgba(179, 179, 179, 1); font-size: 12px"
                >th</sub
              >
              Oct</span
            >
          </p>
          <button type="button">{{ $t("Viewall") }}</button>
        </v-col>
        <v-col cols="12" md="4" lg="3" sm="6">
          <div class="card pa-3">
            <div class="card-body mt-5">
              <div class="user-info justify-start">
                <div class="user-image position-relative">
                  <img
                    class="user-avatar"
                    src="../assets/soft-ware-img/Shape.png"
                    alt=""
                  />
                  <img
                    class="social-icon"
                    src="@/assets/images/icons/facebook.svg"
                    alt=""
                  />
                </div>
                <div>
                  <p>Qarea Company</p>
                  <p
                    style="
                      text-transform: capitalize;
                      color: #237276;
                      font-weight: 500;
                    "
                  >
                    {{ $t("sceduledAt") }} <span>9:23</span>
                  </p>
                </div>
              </div>
              <div class="post-descript mt-5 mb-3">
                <p class="text-left">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  lobortis maximus
                </p>
              </div>
              <div class="post-image">
                <img
                  src="../assets/soft-ware-img/6c6aac76b1efa46691789a9f54ce24cc.jpeg"
                  alt=""
                />
              </div>
              <div class="card-footer mt-3">
                <div class="actions">
                  <v-row class="" style="padding: 10px 14px">
                    <v-col cols="9" class="ma-0 pa-0">
                      <v-btn size="large" class="preview-btn" variant="outlined"
                        >{{ $t("preview") }}
                      </v-btn>
                    </v-col>
                    <v-col cols="2" class="ma-0 pa-0">
                      <button class="edite-post">
                        <Edithome />
                      </button>
                    </v-col>
                    <v-col cols="1" class="ma-0 pa-0">
                      <button class="delete-post">
                        <Deletehome />
                      </button>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <div v-if="mdata">
        <Scheduled :Scheduled="Scheduled" class="mt-15" />

        <v-row class="recent-ads px-4 py-5 mx-1 my-8">
          <v-col
            cols="12"
            md="8"
            lg="8"
            sm="12"
            class="posts-scheduled px-6 py-5 custom-shadow"
          >
            <RecentAds :ads="recentAds" :loading="loading" />
          </v-col>
          <v-col cols="12" md="4" lg="4" sm="12" class="active-ad-acount py-0">
            <ActiveAdAccounts :accounts="activeAccounts" :loading="loading" />
          </v-col>
        </v-row>

        <v-row class="posts-scheduled px-4 py-5 mx-4">
          <v-col cols="12" class="mb-3 header-post">
            <p class="title">{{ $t("recent_posts") }}</p>
            <button type="button" @click="$router.push('/engagement-insights')">
              {{ $t("Viewall") }}
            </button>
          </v-col>
          <RecentPosts :posts="resentposts" :loading="loading" />
        </v-row>
      </div>
      <v-footer class="bg-transparent pt-10 d-flex align-center justify-center">
        <p style="color: rgba(103, 116, 142, 1); font-size: 14px">
          {{ $t("promxa_copy_right") }}
        </p>
      </v-footer>
    </v-container>
  </div>
</template>

<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import { loginForm } from "@/store/logIn";
import Edithome from "@/components/icons/posts/Edithome.vue";
import Deletehome from "@/components/icons/posts/Deletehome.vue";
import Scheduled from "@/components/home/Scheduled.vue";
import RecentAds from "@/components/home/RecentAds.vue";
import ActiveAdAccounts from "@/components/home/ActiveAdAccounts.vue";
import RecentPosts from "@/components/home/RecentPosts.vue";
import apiClient from "@/core/buildRequest";
export default {
  components: {
    GlobalNav,
    Edithome,
    Deletehome,
    Scheduled,
    RecentAds,
    ActiveAdAccounts,
    RecentPosts,
  },
  data() {
    return {
      store: loginForm(),
      globalNavHeight: 0,
      loading: false,
      mdata: false,
      showCampaignCard: false,
      activeAccounts: [
        {
          name: "Qurea Company",
          icon: require("@/assets/images/icons/facebook.svg"),
        },
        {
          name: "Another Company",
          icon: require("@/assets/images/icons/facebook.svg"),
        },
        // ...
      ],
      Scheduled: [],
      resentposts: [
        {
          username: "Ahmed hamdi",
          time: "12/10/2024",
          platformimage: require("@/assets/images/icons/facebook.svg"),
          userimage: require("@/assets/soft-ware-img/Shape.png"),
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
          image: require("@/assets/images/postimage.png"),
          Impressions: 230,
          Engagement: 520,
          Clicks: 1203,
        },
      ],
      recentAds: [
        {
          userAvatar: require("@/assets/soft-ware-img/Shape.png"),
          socialIcon: require("@/assets/images/icons/facebook.svg"),
          accountName: "Qarea Company",
          adName: "Product",
          dailyBudget: 256,
          objective: "Lorem",
          dateRange: "20 Oct To 5 Nov",
        },
      ],
      examplePosts: [
        {
          userAvatar: require("@/assets/soft-ware-img/Shape.png"),
          socialIcon: require("@/assets/images/icons/facebook.svg"),
          companyName: "Qarea Company",
          time: "9:23",
          description: "Lorem ipsum dolor sit amet...",
          image: require("@/assets/images/postimage.png"),
        },
      ],
      modules: [
        {
          id: "campaign",
          icon: require("@/assets/soft-ware-img/asSteDetails.svg"),
          label: "CreateAD/Campaign",
          to: "/create-new-camp",
          permission: "campaign-ads.create",
        },
        {
          id: "leads",
          icon: require("@/assets/soft-ware-img/leadsMangement.svg"),
          label: "LeadsManagement",
          to: "/leads-management",
          permission: "leads-managment.read",
        },
        {
          id: "dm",
          icon: require("@/assets/soft-ware-img/massage-center.svg"),
          label: "MessagesCenter",
          to: "/messages-center",
          permission: "dm.create",
        },
        {
          id: "superad",
          icon: require("@/assets/images/AD21.svg"),
          label: "Super_Ad",
          to: "/super-ad",
          permission: "super-ad.create",
        },
        {
          id: "calendar",
          icon: require("@/assets/soft-ware-img/adsCalender.svg"),
          label: "calender",
          to: "/calender",
          permission: "calender.read",
        },
        {
          id: "performance",
          icon: require("@/assets/soft-ware-img/adsPerformance.svg"),
          label: "ADsPerformance",
          to: "/ads-performance",
          permission: "ad-performance.read",
        },
        {
          id: "publish",
          icon: require("@/assets/soft-ware-img/puplishPost.svg"),
          label: "PublishPosts",
          to: "/publish-post",
          permission: "publish-posts.create",
        },
        {
          id: "insights",
          icon: require("@/assets/soft-ware-img/Engagement&Insights.svg"),
          label: "engagement_and_insights",
          to: "/engagement-insights",
          permission: "engagement-insights.read",
        },
        {
          id: "drive",
          icon: require("@/assets/soft-ware-img/homePageIconMyDrive.svg"),
          label: "MyDrive",
          to: "/drive-center",
          permission: "my-drive.read",
        },
        {
          id: "team",
          icon: require("@/assets/soft-ware-img/myTeamHomePage.svg"),
          label: "MyTeam",
          to: "/my-team",
          permission: "my-team.read",
        },
        {
          id: "finance",
          icon: require("@/assets/soft-ware-img/financeCenter.svg"),
          label: "FinanceCenter",
          to: "/finance-home",
          permission: "finance-center.read",
        },
        {
          id: "integration",
          icon: require("@/assets/soft-ware-img/integrationsIcon.svg"),
          label: "Integrations",
          to: "/integrations",
          permission: "integration.read",
        },
        {
          id: "account",
          icon: require("@/assets/soft-ware-img/myAccountHomePage.svg"),
          label: "MyAccount",
          to: "/my-account",
          permission: "my-account.read",
        },
      ],
    };
  },
  methods: {
    HavePermission(p) {
      return this.store?.permissions?.includes(p) || false;
    },
    async getAllPostsd() {
      try {
        var response = await apiClient.get(`/home-page`);
        console.log(response);
        const Postresponse = response.data.data;
        this.recentAds = Postresponse.recent_ads;
        this.resentposts = Postresponse.recent_posts;
        this.activeAccounts = Postresponse.active_ad_accounts;
        this.Scheduled = Postresponse.scheduled_posts;
        this.mdata = true;
      } catch (err) {
        console.error("Error fetching getAllPostsd:", err);
      } finally {
        this.loading = true;
      }
    },
    getModuleData(id){
      if(id === "publish" && (localStorage.getItem("postId") || localStorage.getItem("editePostId"))){
        localStorage.removeItem("postId");
        localStorage.removeItem("editePostId");
        this.$router.push("/publish-post");
      }
    }
  },
  mounted() {
    this.globalNavHeight = this.$refs.globalNav.$el.offsetHeight;
    this.getAllPostsd();
    
  },
};
</script>

<style scoped>
.modules-type {
  padding: 3rem 1rem 0 1rem;
}
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
}
.card .header {
  background: linear-gradient(90deg, #1f666a 0%, #4f979f 69%);
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  box-shadow: 0px 0px 24px 0px #808080;
  margin-bottom: 8px;
}
.card-body p {
  font-weight: 500;
  color: #333;
  font-size: 14px;
  line-height: 1.2;
}
@media only screen and (max-width: 600px) {
  .iconhed {
    width: 2rem;
    height: 2rem;
  }
}
@media only screen and (min-width: 600px) {
  .iconhed {
    width: 2.15rem;
    height: 2.15rem;
  }
}
@media only screen and (min-width: 768px) {
}
@media only screen and (min-width: 992px) {
  .card .header {
    width: 7rem;
    height: 7rem;
  }
  .modules-type {
    padding: 5rem 1rem 0 1rem;
  }
}
@media only screen and (min-width: 1200px) {
}
.custom-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);
}
.post-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08), 0px 0px 12px rgba(0, 0, 0, 0.08);
}
</style>
